// extracted by mini-css-extract-plugin
export default {"tooltip":"LY96ihz0tSz7eNi2Xj1A","options":"SHb6NJ9dNJeBaC75Vqs0"};